
// XXX_INTERNAL - allows to connect directly to another docker container. Will not work with Client Side Render !!!
// XXX_EXTERNAL - allows to connect to endpoint via domain. Will work both with SSR (avoid using) and CSR.
// XXX_NODE     - connects to node endpoint and exists only for frontend purposes.

export const API_BUILDER_INTERNAL = process.env.NEXT_PUBLIC_API_BUILDER_INTERNAL;
export const API_BUILDER_EXTERNAL = process.env.NEXT_PUBLIC_API_BUILDER_EXTERNAL;
export const API_BUILDER_NODE = `/api/builder`;
//------------------
//           Info
//------------------
export const API_BUILDER_DEPLOYMENTS_GET_NODE = `${API_BUILDER_NODE}/deployments`;
export const API_BUILDER_PROJECTS_GET_NODE = `${API_BUILDER_NODE}/projects`;
//------------------
//           Project
//------------------
export const API_BUILDER_PROJECT_INTERNAL = `${API_BUILDER_INTERNAL}/project`;
export const API_BUILDER_PROJECT_NODE = `${API_BUILDER_NODE}/project`;
//------------------
//           Cloud
//------------------
export const API_BUILDER_TOKEN_INTERNAL = `${API_BUILDER_INTERNAL}/cloud`;
export const API_BUILDER_TOKEN_NODE = `${API_BUILDER_NODE}/tokens`;
//------------------
//           Deployment
//------------------
export const API_BUILDER_DEPLOY_NODE = `${API_BUILDER_NODE}/deploy`;
//------------------
//           Agreement
//------------------
export const API_AGREEMENT_OWN_EXTERNAL = `${API_BUILDER_EXTERNAL}/agreement`
//        --
export const API_AGREEMENT_OWN_ACCEPTED_EXTERNAL = `${API_AGREEMENT_OWN_EXTERNAL}/accepted`;
